import { PatientCareProviderModel } from "one-card-pcp";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * pcp Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */

    let pdata: PatientCareProviderModel[] = [];

    let result :any = {
        pcp:pdata,
        error:undefined

    }
    const { log } = context;
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
       result.error=response;
    }
    if (response && response[0]?.members?.length > 0) {
        response[0].members.forEach((pcpdata:any)=>{
            let pcpobj: PatientCareProviderModel = {};
            //OR condition was added for NYCHHC as the response was different
            pcpobj.name = pcpdata.name ?? '';
            pcpobj.address = pcpdata.address1 ?? '';
            pcpobj.phonenumber = pcpdata.phonenumber ?? '';
            pdata.push(pcpobj)
        });
    }
    result.pcp=pdata;
    log.debug(
        "ccw-gadget,pcp-epic",
        "pcp-epic transforamtion response ", {
        result
    });
    return result;
}